import React, { useEffect, useRef, useState } from 'react';
import AppHeader from './AppHeader';
import { lookupParkingCredential } from '../api';

function Parking({ user, onLogout, onNavigate }) {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const queryInputRef = useRef(null);

  const focusSearch = () => {
    window.setTimeout(() => {
      queryInputRef.current?.focus();
      queryInputRef.current?.select();
    }, 0);
  };

  useEffect(() => {
    focusSearch();
  }, []);

  const handleNext = () => {
    setResult(null);
    setError('');
    setQuery('');
    focusSearch();
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = query.trim();
    if (!trimmed) {
      setResult(null);
      setError('Enter a season pass number');
      return;
    }
    setLoading(true);
    try {
      const data = await lookupParkingCredential(trimmed);
      setResult(data.result || null);
      if (!data.result) {
        setError('No parking result returned');
      }
    } catch (err) {
      setResult(null);
      setError(err.error || 'Lookup failed');
    } finally {
      setLoading(false);
    }
  };

  const showResult = Boolean(result);
  const level = result?.level;
  const label =
    level === 'preferred'
      ? 'Preferred'
      : level === 'general'
        ? 'General'
        : level === 'other'
          ? result.label || 'Parking'
          : 'No Parking';

  return (
    <div className="container parking-page">
      <AppHeader
        user={user}
        pageTitle="Parking"
        subtitle="Scan a season pass — Preferred or General parking"
        onNavigate={onNavigate}
        onLogout={onLogout}
        active="parking"
      />

      {error && <div className="error">{error}</div>}

      {!showResult && (
        <form onSubmit={handleSearch} className="gate-search parking-search">
          <label htmlFor="parking-query">Season pass number</label>
          <div className="gate-search-row">
            <input
              ref={queryInputRef}
              id="parking-query"
              type="text"
              autoFocus
              autoComplete="off"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="SFSP-88421"
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Searching…' : 'Search'}
            </button>
          </div>
        </form>
      )}

      {showResult && (
        <div className="parking-result">
          <div
            className={
              level === 'preferred'
                ? 'parking-level preferred'
                : level === 'general'
                  ? 'parking-level general'
                  : level === 'other'
                    ? 'parking-level other'
                    : 'parking-level none'
            }
            aria-live="polite"
          >
            {label}
          </div>

          <p className="parking-guest-name">{result.guestName || 'Guest'}</p>
          <p className="subtitle">
            {result.credential}
            {result.matchedPerk?.title ? ` · ${result.matchedPerk.title}` : ''}
          </p>

          <button type="button" className="btn-primary parking-next" onClick={handleNext} autoFocus>
            Next pass
          </button>
        </div>
      )}
    </div>
  );
}

export default Parking;
